













import { Component, Vue, Prop } from "vue-property-decorator";
import { clamp } from "@/domainproject/helpers";

@Component({
  watch: {
    value: function(this: ScaleSlider) {
      this.updateCanvas();
    },
    mousedown: function(this: ScaleSlider) {
      this.updateCanvas();
    },
    color: function(this: ScaleSlider) {
      this.updateCanvas();
    },
    inv: function(this: ScaleSlider) {
      this.updateCanvas();
    }
  }
})
export default class ScaleSlider extends Vue {
  @Prop() color!: string;
  @Prop() initialScale!: number;

  value = 0.5;
  min = 0.1;

  mousedown = false;
  initial = true;

  get canvas(): HTMLCanvasElement {
    return this.$refs["canvas"] as HTMLCanvasElement;
  }

  mousemove(event: MouseEvent) {
    if (!this.mousedown) return;
    this.value = clamp(event.offsetX / this.canvas.width, 0, 1);
  }

  mouseup() {
    this.mousedown = false;
  }

  mounted() {
    // Get inverse.
    const logx = Math.pow(this.initialScale, 1 / Math.log(10));
    const v = logx / (logx + 1);
    this.value = (v - this.min) / (1 - this.min * 2);
    document.body.addEventListener("mouseup", this.mouseup, false);
    this.initial = true;
    this.updateCanvas();
    this.initial = false;
  }

  destroyed() {
    document.body.removeEventListener("mouseup", this.mouseup, false);
  }

  updateCanvas() {
    const ctx = this.canvas.getContext("2d")!;
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    ctx.fillStyle = this.mousedown ? `${this.color}33` : `${this.color}77`;
    ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

    const value = this.value * (1 - this.min * 2) + this.min;
    const scale = 10 ** Math.log(value / (1 - value));

    if (!this.mousedown && !this.initial) this.$emit("scale", scale);

    ctx.fillStyle = this.mousedown ? `${this.color}dd` : this.color;
    ctx.fillRect(0, 0, this.canvas.width * this.value, this.canvas.height);
  }
}
